// import { HistoryIcons } from './OrderHistoryStyled';
import {
	DetailDivider,
	DetailItemContainer,
	DetailItemLeft,
	DetailItemModifiers,
	DetailItemTitle,
	DetailLeftRight,
	DetailPriceRight
} from './OrderDetailStyled';

export type OrderDetailItemLayoutProps = {
	icon: JSX.Element | string;
	name: JSX.Element | string;
	id: JSX.Element | string;
	price: string;
	modifiers: [
		{
			modifier: {
				name: string;
			};
		}
	];
};

export const OrderDetailItemsLayout: React.FC<OrderDetailItemLayoutProps> = ({
	icon,
	name,
	modifiers,
	price
	// children
}) => {
	const handleModifiers = () => {
		if (modifiers.length > 1) {
			return modifiers.map(e => e.modifier.name + ', ');
		} else return modifiers.map(e => e.modifier.name);
	};
	return (
		<>
			<DetailItemContainer>
				<DetailItemLeft>{icon}</DetailItemLeft>

				<DetailLeftRight>
					<DetailItemTitle>{name}</DetailItemTitle>
					<DetailItemModifiers>
						{handleModifiers()}
					</DetailItemModifiers>
				</DetailLeftRight>
				<DetailPriceRight>${price}</DetailPriceRight>
			</DetailItemContainer>
			<DetailDivider></DetailDivider>
		</>
	);
};
